import { render, staticRenderFns } from "./custom-bar-gauge-legend-template.vue?vue&type=template&id=7fbb7e56&"
import script from "./custom-bar-gauge-legend-template.vue?vue&type=script&lang=js&"
export * from "./custom-bar-gauge-legend-template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports